import memberstackDOM from '@memberstack/dom';

// Initialize Memberstack with custom auth domain for cookie-based auth
const memberstack = memberstackDOM.init({
  domain: "https://memberstack-client.getbokr.com",
  publicKey: "pk_5fa28b3c5d0590fd0849",
  useCookies: true,
  setCookieOnRootDomain: true,
});

export default memberstack;
